import type { ComponentProps } from "react"
import { createLink } from "@tanstack/react-router"
import { ArrowLeft } from "lucide-react"
import { Button } from "@/components/ui/button"

function BackAnchor({ label, ...props }: ComponentProps<"a"> & { label: string }) {
	return <Button asChild variant="secondary" size="icon-circle">
		<a {...props} aria-label={label} title={label}><ArrowLeft aria-hidden="true" /></a>
	</Button>
}

export const PageBackLink = createLink(BackAnchor)
